import script from "./ToolTip.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolTip.vue?vue&type=script&setup=true&lang=js"

import "./ToolTip.vue?vue&type=style&index=0&id=5b6a7ce3&scoped=true&lang=css"

import exportComponent from "/home/tml/work/WP-plugins/wpaprsdb/wpaprsdb/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b6a7ce3"]])

export default __exports__